import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../action/ActionArgs'
import type { LogisticVendorOrShipToEnum } from './LogisticVendorOrShipToEnum'

@InputType()
export class UpdateLogisticVendorOrShipToArgs extends ActionArgs {
  @Field(() => String)
  userId: string

  @Field(() => String)
  type: LogisticVendorOrShipToEnum

  @Field(() => String)
  logisticId: string

  @Field(() => String)
  email: string

  @Field(() => String)
  name?: string

  @Field(() => String)
  companyId?: string

  @Field(() => String)
  companyName?: string

  @Field(() => Boolean)
  skipDomain?: boolean
}
